import SettingsPage from "./Settings";

export default SettingsPage;
